import { DocumentListCard } from '@yes.technology/react-toolkit'
import DataTables from '../../DataTables/DataTables'
import { Title } from '../Cockpit.styles'
import { ChartTemplate } from '../Cockpit.types'
import { Container } from './styles'

type DataTablesChartProps = {
  props?: ChartTemplate['props']
  title: string
}

const DataTablesChart = ({ props, title }: DataTablesChartProps) => {
  if (!props) return null

  return (
    <Container>
      <Title>{title}</Title>
      <DocumentListCard style={{ padding: 0 }}>
        <DataTables
          props={{
            ...props
          }}
        />
      </DocumentListCard>
    </Container>
  )
}

export default DataTablesChart
